import { useQyGetDashboard } from "@factory/query/dashboard.query";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Divider } from "primereact/divider";
import { Sidebar } from "primereact/sidebar";
import { useState } from "react";

import { FilterDashboard } from "../filter-dashboard/filter-dashboard";
import { useFilterDashboardContext } from "../filter-dashboard/filter-dashboard.context";
import PieChart from "../pie-chart/pie-chart";

export function ListDetails() {
  const [filterPanel, setFilterPanel] = useState(false);
  const { filterChipsElement, getFilterEntityValues } =
    useFilterDashboardContext();
  const colorArray = [
    "bg-green-200",
    "bg-blue-200",
    "bg-teal-200",
    "bg-amber-200",
    "bg-lime-200",
    "bg-cyan-200",
    "bg-rose-200",
    "bg-fuchsia-200",
    "bg-purple-200",
  ];
  const { data: dashboardResponse } = useQyGetDashboard(
    "",
    getFilterEntityValues()
  );
  const dashboardData = dashboardResponse || [];

  // const statusData = dashboardData
  //   .map((item, index) => {
  //     const itemValue = isTextAboutMoney(item.label ?? "")
  //       ? currencyFormat(item.value ?? 0)
  //       : numberFormat(item.value || 0);
  //     return new DashboardModel(
  //       item.label || "-",
  //       itemValue,
  //       <FaBuilding />,
  //       undefined,
  //       undefined,
  //       colorArray[index]
  //     );
  //   });

  // THIS ARE THE LOCAL RENDERS
  const filterElement = (
    <section>
      <div className="flex gap-4 items-center mb-2 justify-end">
        <Button
          label="Filter"
          severity="secondary"
          badgeClassName="p-badge-danger"
          onClick={() => setFilterPanel(true)}
          outlined
        />
        {/* <Button
          label="Download Report"
          badgeClassName="p-badge-danger"
          onClick={() => setFilterPanel(true)}
          outlined
        /> */}
      </div>

      {filterChipsElement}
      <Sidebar visible={filterPanel} onHide={() => setFilterPanel(false)}>
        <FilterDashboard />
      </Sidebar>
    </section>
  );
  return (
    <div id="Dashboard" className="dashboard p-7">
      <div className="flex justify-between items-center mb-4">
        <h1 className="mb-4">Dashboard</h1>
        {filterElement}
      </div>
      <section className="mb-10">
        <section className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* {dashboardData?.map((item, id) => (
            <DashboardCard key={id} model={item} />
          ))} */}
          <PieChart title="Count by Status" total_data={dashboardData?.[0]?.value as any} />
          <PieChart title="Quotation vs Invoice" total_data={dashboardData?.[1]?.value as any} />
        </section>
        <Divider />
        <section className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* {dashboardData?.[2]?.map((item, id) => (
            <DashboardCard key={id} model={item} />
          ))} */}
          <div className="flex flex-col p-2 bg-white border rounded-sm">
          <span className="block text-gray-500 font- text-sm">Top Packages</span>
          <DataTable value={dashboardData?.[2]?.value as any}>
            <Column field="label" header="Package" sortable></Column>
            <Column field="value" header="No" sortable></Column>
          </DataTable>
          </div>
          <div className="flex flex-col p-2 bg-white border rounded-sm">
          <span className="block text-gray-500 font- text-sm">Top Services</span>
          <DataTable value={dashboardData?.[3]?.value as any}>
            <Column field="label" header="Package" sortable></Column>
            <Column field="value" header="No" sortable></Column>
          </DataTable>
          </div>
          <div className="flex flex-col p-2 bg-white border rounded-sm">
          <span className="block text-gray-500 font- text-sm">Top Accommodation</span>
          <DataTable value={dashboardData?.[4]?.value as any}>
            <Column field="label" header="Package" sortable></Column>
            <Column field="value" header="No" sortable></Column>
          </DataTable>
          </div>
        </section>
      </section>
    </div>
  );
}

export default ListDetails;
